import React, { useState, useEffect } from 'react';
import { useNavigate, Outlet, useLocation, Link } from 'react-router-dom';
import logoImg from "../image/logo.png";
import instagramIcon from "../image/instagram-icon.svg";
import emailIcon from "../image/email-icon.svg";
import vimeoIcon from "../image/vimeo-icon.svg";
import "./font.css";

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('new-project');
  
  useEffect(() => {
    const path = location.pathname;
    if (path.includes('our-projects')) {
      setActiveTab('our-projects');
    } else if (path.includes('selebrity')) {
      setActiveTab('selebrity');
    } else {
      setActiveTab('new-project');
    }
  }, [location]);

  const handleTabChange = (tab) => {
    if (tab !== activeTab) {
      setActiveTab(tab);
      navigate(`/admin/${tab}`);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_auth');
    localStorage.removeItem('admin_timestamp');
    navigate('/admin/login');
  };

  const styles = {
    adminLayout: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: '#161719',
      color: 'white',
    },
    
    adminHeader: {
      background: '#161719',
      padding: '20px 30px 0 30px',
    },
    
    adminLogoCenter: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: '20px',
      position: 'relative',
    },
    
    logo: {},
    
    logoImage: {
      height: '80px',
      width: 'auto',
    },
    
    logoutButton: {
      position: 'absolute',
      right: '0',
      top: '50%',
      transform: 'translateY(-50%)',
      padding: '8px 20px',
      background: 'transparent',
      color: 'white',
      border: '1px solid #333',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '14px',
      transition: 'all 0.3s',
    },
    
    adminTitle: {
      marginTop: '10px',
    },
    
    adminTitleH1: {
      fontSize: '64px',
      fontWeight: '600',
      letterSpacing: '1px',
    },
    
    adminTabs: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
      padding: '0',
    },
    
    tabButton: {
      width: '177px',
      height: '60px',
      padding: '0',
      background: '#00000000',
      border: '1px solid #333',
      color: 'white',
      fontSize: '14px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s',
      textTransform: 'uppercase',
      letterSpacing: '1px',
      borderRadius: '32px',
      margin: '0',
    },
    
    tabButtonActive: {
      background: '#c5c5c531',
      color: '#ffffff',
      borderColor: '#c5c5c500',
    },
    
    adminMain: {
      flex: '1',
      padding: '30px',
      width: '100%',
    },
    
    adminFooter: {
      background: '#07070700',
      borderTop: '1px solid #333',
      padding: '20px 30px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    
    footerLeft: {
      color: '#e7e7e7',
      fontSize: '14px',
    },
    
    footerSocial: {
      display: 'flex',
      gap: '20px',
      color: '#e7e7e7',
      alignItems: 'center',
    },
    
    socialIcon: {
      width: '20px',
      height: '20px',
      filter: 'invert(1)',
      transition: 'filter 0.3s',
    },
  };

  return (
    <div style={styles.adminLayout}>
      <header style={styles.adminHeader}>
        <div style={styles.adminLogoCenter}>
          <div style={styles.logo}>
            <Link to="/home">
              <img src={logoImg} alt="Logo" style={styles.logoImage} />
            </Link>
          </div>
          <button 
            onClick={handleLogout} 
            style={styles.logoutButton}
            onMouseEnter={(e) => {
              e.currentTarget.style.border = '1px solid #C5C5C5';
              e.currentTarget.style.background = 'rgba(197, 197, 197, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.border = '1px solid #333';
              e.currentTarget.style.background = 'transparent';
            }}
          >
            Log out
          </button>
          <div style={styles.adminTitle}>
            <h1 style={styles.adminTitleH1}>ADMIN PANEL</h1>
          </div>
        </div>
        
        <div style={styles.adminTabs}>
          <button 
            style={{
              ...styles.tabButton,
              ...(activeTab === 'new-project' ? styles.tabButtonActive : {})
            }}
            onClick={() => handleTabChange('new-project')}
            onMouseEnter={(e) => {
              if (activeTab !== 'new-project') {
                e.currentTarget.style.background = '#00000000';
                e.currentTarget.style.border = '1px solid #c5c5c542';
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== 'new-project') {
                e.currentTarget.style.background = '#00000000';
                e.currentTarget.style.border = '1px solid #333';
              }
            }}
          >
            NEW PROJECT
          </button>
          
          <button 
            style={{
              ...styles.tabButton,
              ...(activeTab === 'our-projects' ? styles.tabButtonActive : {})
            }}
            onClick={() => handleTabChange('our-projects')}
            onMouseEnter={(e) => {
              if (activeTab !== 'our-projects') {
                e.currentTarget.style.background = '#00000000';
                e.currentTarget.style.border = '1px solid #c5c5c542';
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== 'our-projects') {
                e.currentTarget.style.background = '#00000000';
                e.currentTarget.style.border = '1px solid #333';
              }
            }}
          >
            OUR PROJECTS
          </button>
          
          <button 
            style={{
              ...styles.tabButton,
              ...(activeTab === 'selebrity' ? styles.tabButtonActive : {})
            }}
            onClick={() => handleTabChange('selebrity')}
            onMouseEnter={(e) => {
              if (activeTab !== 'selebrity') {
                e.currentTarget.style.background = '#00000000';
                e.currentTarget.style.border = '1px solid #c5c5c542';
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== 'selebrity') {
                e.currentTarget.style.background = '#00000000';
                e.currentTarget.style.border = '1px solid #333';
              }
            }}
          >
            SELEBRITY
          </button>
        </div>
      </header>

      <main style={styles.adminMain}>
        <Outlet />
      </main>

      <footer style={styles.adminFooter}>
        <div style={styles.footerLeft}>
          <span>© 2026 MOVIE PARK</span>
        </div>
        <div style={styles.footerSocial}>
          <a href="https://www.instagram.com/movie_park/" target="_blank" rel="noopener noreferrer">
            <img src={instagramIcon} alt="Instagram" style={styles.socialIcon} />
          </a>
          <a href="https://vimeo.com/movieparkco" target="_blank" rel="noopener noreferrer">
            <img src={vimeoIcon} alt="Vimeo" style={styles.socialIcon} />
          </a>
          <a href="mailto:hello@movieparkpro.com" target="_blank" rel="noopener noreferrer">
            <img src={emailIcon} alt="Email" style={styles.socialIcon} />
          </a>
        </div>
      </footer>
    </div>
  );
};

export default AdminLayout;